import App from "../components/App";

const indexRoutes = [
  { path: "/", component: App }
  //   { path: "/", component: TestReduxComponent }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js